import { Text, Input, TextArea } from '@atoms/index';
import { Button } from '@ui/atoms/design-system';
import { contactUsForm } from '@components/ContactUs/helper';
import texts from '@components/ContactUs/en.json';
import useWindowDimensions from 'hooks/useWindowDimensions';

const ContactForm = ({ onSubmit, loading, contactFormRef }) => {
    const { width } = useWindowDimensions();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = contactFormRef;

    return (
        <div className="w-full">
            <Text
                content={contactUsForm.title}
                className=" text-primary-500 h4-semibold mb-4"
                htmlTag='h2'
            />
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex flex-col gap-4"
            >
                {contactUsForm.fields.map((field, index) => (
                    <div className="" key={index}>
                        {field.type === 'text' && (
                            <Input
                                id={field.id}
                                type="text"
                                register={register}
                                label={field.label}
                                labelClass="p5-medium text-basicBlack"
                                height='h-[58px]'
                                borderWeight="border-[1.5px]"
                                className="placeholder:p4-regular placeholder:text-gray-400"
                                error={errors[field.id]}
                                placeholder={field.placeholder}
                            />
                        )}
                        {field.type === 'textarea' && (
                            <TextArea
                                id={field.id}
                                register={register}
                                label={field.label}
                                labelClass="p5-medium text-basicBlack"
                                height="h-[120px] xl:h-[156px]"
                                borderWeight="border-[1.5px]"
                                className="placeholder:p4-regular placeholder:text-gray-400"
                                wrapperClass=""
                                placeholder={field.placeholder}
                            />
                        )}
                    </div>
                ))}
                <Button
                    type={texts?.Submit}
                    widthClass={'w-full'}
                    buttonSize={width < 768 ? 'regular' : 'large'}
                    buttonText={contactUsForm.ctaText}
                    isLoading={loading}
                />
            </form>
        </div>
    );
};

export default ContactForm;
